import { EyeOpenIcon } from '@radix-ui/react-icons'
import { useKestrel } from 'features/kestrelViewer'
import { useKestrelTutorialContext } from 'features/kestrelViewer/tutorial/KestrelTutorialContext'
import { SubmenuComponent } from 'features/kestrelViewer/ui/tools/SubmenuComponent'
import { ToggleLabelsButton } from 'features/kestrelViewer/ui/tools/ToggleLabelsButton'
import { ToggleMeasurementLabelsButton } from 'features/kestrelViewer/ui/tools/ToggleMeasurementLabelsButton'
import { ChangeTextureButton } from 'features/kestrelViewer/ui/tools/viewControls/ChangeTextureButton'
import { ResetViewButton } from 'features/kestrelViewer/ui/tools/viewControls/ResetViewButton'
import { Toggle2DPlaneButton } from 'features/kestrelViewer/ui/tools/viewControls/Toggle2DPlaneButton'
import { ToggleCameraPosesButton } from 'features/kestrelViewer/ui/tools/viewControls/ToggleCameraPosesButton'
import React from 'react'

export const ViewControlsSubmenu: React.FC = () => {
  const { gatekeeper } = useKestrel()
  const { forceViewControlsSubmenuOpen } = useKestrelTutorialContext()

  return (
    <SubmenuComponent
      label='View Controls'
      icon={<EyeOpenIcon width={22} height={22} color={'white'} />}
      forceOpen={forceViewControlsSubmenuOpen}>
      <ResetViewButton />
      <ToggleLabelsButton />
      <ToggleMeasurementLabelsButton />
      {gatekeeper.feature.changeTexture && <ChangeTextureButton />}
      {gatekeeper.feature.plane2D && <Toggle2DPlaneButton />}
      {gatekeeper.feature.cameraPoses && <ToggleCameraPosesButton />}
    </SubmenuComponent>
  )
}
